module.exports = __webpack_public_path__ + "static/media/jpg.fb69e671.svg";